import { render, staticRenderFns } from "./djgls.vue?vue&type=template&id=6aed0b6a&scoped=true&"
import script from "./djgls.vue?vue&type=script&lang=js&"
export * from "./djgls.vue?vue&type=script&lang=js&"
import style0 from "./djgls.vue?vue&type=style&index=0&id=6aed0b6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aed0b6a",
  null
  
)

export default component.exports